<template>
  <span class="red">{{ overTime == 0 ? ' 0 秒 ' : day + '天'  + hour + '小时' + minute + '分' + second + '秒'}}</span>
</template>
<script>
export default {
  data() {
    return {
      day: "0",
      hour: "0",
      minute: "00",
      second: "00",
      timer: null,
      overTime: 0
    };
  },
  props: {
    endTime: {
      type: String,
      default: '0'
    }
  },
  watch: {
    endTime: function() {
      this.timer && clearTimeout(this.timer);
      this.overTime = Number(this.endTime);
      this.countdownWait();
    }
  },
  mounted() {
    this.overTime = Number(this.endTime);
    this.countdownWait();
  },
  methods: {
    countdownWait() {
      if (this.overTime <= 0) {
        this.timer && clearTimeout(this.timer);
        return;
      }

      this.day = this.getOverDays(this.overTime);
      this.hour = this.getOverHours(this.overTime);
      this.minute = this.getOverMinutes(this.overTime);
      this.second = this.getOverSeconds(this.overTime);

      this.timer = setTimeout(() => {
        this.overTime = this.overTime - 1000;
        this.countdownWait();
      }, 1000);
    },

    getOverDays(over) {
      return Math.floor(over / (24 * 60 * 60 * 1000));
    },

    getOverHours(over) {
      return Math.floor((over % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    },

    getOverMinutes(over) {
      return this.formatNumber(
        Math.floor(
          ((over % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) / (60 * 1000)
        )
      );
    },

    getOverSeconds(over) {
      return this.formatNumber(
        Math.floor(
          (((over % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) % (60 * 1000)) /
            1000
        )
      );
    },

    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    }
  }
};
</script>
<style>
.red {
  color: red;
}
</style>
